<template>
  <div>
    redirecting
  </div>
</template>

<script>
export default {
  mounted() {
    if (sessionStorage.getItem('sessionTimeOut')) {
      this.isSessionTimeOut = true
    } else {
      this.isSessionTimeOut = false
    }
    sessionStorage.clear()

    const params = { screen_hint: 'signup' }

    if (this.$route.query.email) {
      params.login_hint = this.$route.query.email
    }

    this.$auth.loginWithRedirect(params)
  }
}
</script>

<style lang="scss" scoped></style>
